export const hasData = response => Boolean(
  response && response.success && response.data && response.data.length > 0
)

export const hasObjects = response => Boolean(
  response && response.success && response.data?.objects && response.data.objects.length > 0
)
